'use client';

import { useRouter, usePathname, useSearchParams } from 'next/navigation';
import { useLanguageFromPath } from '@/hooks/useLanguageFromPath';
import { useTranslation } from 'react-i18next';
import { LanguageSelectorUI, type Language } from '@/components/ui/language-selector-ui';

const languages: Language[] = [
  { name: 'English', slug: 'en' },
  { name: 'Русский', slug: 'ru' },
];

export default function MainPageLanguageSelector() {
  const currentLang = useLanguageFromPath();
  const { i18n } = useTranslation();
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();

  const handleLangChange = async (newLang: string) => {
    // Change i18n in background (don't await)
    i18n.changeLanguage(newLang).catch(() => {});

    // Get current page path without language prefix
    const pathWithoutLang =
      pathname === '/ru' || pathname === '/'
        ? ''
        : pathname.startsWith('/ru/')
        ? pathname.slice(3)
        : pathname;

    // Navigate to same page in new language
    const newPath =
      newLang === 'ru' ? `/ru${pathWithoutLang}` : pathWithoutLang || '/';

    // Preserve query parameters
    const queryString = searchParams.toString();
    const finalPath = queryString ? `${newPath}?${queryString}` : newPath;

    router.push(finalPath);
  };

  return (
    <LanguageSelectorUI
      currentLang={currentLang}
      languages={languages}
      onValueChange={handleLangChange}
    />
  );
}
